import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18next';
import { NotificationsProvider } from '@mantine/notifications';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://465235774ece431ab104f90a4a6ad8e6@o1280144.ingest.sentry.io/4504921110282240",
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
// });
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <NotificationsProvider position="top-right" limit={1} autoClose={2000}>
    <App/>
    </NotificationsProvider>
);

